export const SKU_REGEX = /^\d{10}$/;

export const normalizeSku = (value) => String(value ?? "").trim();

export const isValidSku = (value) => SKU_REGEX.test(normalizeSku(value));

export const parseSkuInput = (
  input = "",
  { splitPattern = /\r?\n/, dedupe = true } = {},
) => {
  const entries = String(input || "")
    .split(splitPattern)
    .map((value) => normalizeSku(value))
    .filter(Boolean);

  const validSkus = [];
  const invalidSkus = [];
  const seen = new Set();
  let validCountBeforeDedupe = 0;

  entries.forEach((value) => {
    if (!isValidSku(value)) {
      invalidSkus.push(value);
      return;
    }

    validCountBeforeDedupe += 1;

    if (dedupe) {
      if (seen.has(value)) return;
      seen.add(value);
    }

    validSkus.push(value);
  });

  return {
    totalEntries: entries.length,
    validSkus,
    invalidSkus,
    duplicatesRemoved: Math.max(0, validCountBeforeDedupe - validSkus.length),
  };
};

export const buildInvalidSkuMessage = (invalidCount) =>
  `Skipped ${invalidCount} invalid SKU${invalidCount > 1 ? "s" : ""}. SKUs must be numeric and exactly 10 digits.`;
